// @flow
import client from '../../client'

// Constants
export const REGISTER_ENDPOINT = '/corporate/user/'

// Types
export type CorporateUser = {
  book_for_others: Boolean,
  first_name: string,
  last_name: string,
  email: string,
  phone_number: string,
  country_code_name: string,
}

/**
 * Registers a corporate user
 * @param {Object} data Corporate user information
 * @param {string} data.first_name User's first name
 * @param {string} data.last_name User's last name
 * @param {string} data.email User's email
 * @param {string} data.password User's password
 * @param {string} [data.phone_number] User's phone number
 * @param {string} [data.country_code_name] User's phone number country code
 * @param {string} [data.corp_id] Company slug
 * @param {Boolean} [data.book_for_others] Booking for other
 * @return {Promise|Error} A resolved Promise with User data or Rejected with an Error
 */
export const register = (data: {
  first_name: string,
  last_name: string,
  email: string,
  password: string,
  phone_number?: string,
  country_code_name?: string,
  corp_id?: string,
  book_for_others?: Boolean,
}): Promise<CorporateUser> =>
  client.post(REGISTER_ENDPOINT, {
    body: data,
  })

export default register
